import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 16.8.",
  "description": "",
  "published": "2011-08-16T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-16-8/swizec/2211"],
  "categories": "Caffeine, Faux pas, Health, Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-Lac_de_Faux2.jpg",
        "alt": "Lac de Faux",
        "title": "Lac de Faux"
      }}></img></p>
    <p>{`Today I learned that being sent to the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Head_teacher",
        "title": "Head teacher"
      }}>{`headmaster`}</a>{`'s office (figuratively) is a pretty Interesting Experience (tm). I seem to have committed a social `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Faux_pas",
        "title": "Faux pas"
      }}>{`faux pas`}</a>{` and had to be reprimanded for it. Might even have to make some sort of grand public gesture to make it all better ... or at least that was an idea I gave to fix the situation and the persons I spoke to seemed quite interested in it.`}</p>
    <p>{`But this is really a lesson in acting first and asking questions later. Sometimes you see an opportunity and you just go for it, making sure you are allowed to go for it will take so long the opportunity will pass and on more often than not whatever you do is something that isn't that big a deal and you would have just wasted a wonderful opportunity by making sure.`}</p>
    <p>{`Another thing that I learned is that using `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Caffeine",
        "title": "Caffeine"
      }}>{`caffeine`}</a>{` irresponsibly does not work. It's just not a good idea. I've had too many teas in the morning to prime me up for the headmaster visit ... this caused my caffeine to spike, which meant that I needed more caffeine in the afternoon to avoid a crash.`}</p>
    <p>{`This only led to even more problems because it's not even half past midnight yet and I'm crashing so much I need another cup of tea if I'm to finish the work I've set out to finish today.`}</p>
    <p>{`When using my drugs more responsibly I don't crash until 3am ... lesson learned, no matter what, use discipline in drug abuse!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-29-7/swizec/2022"
        }}>{`I learned two things today 29.7.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://junaidghory.wordpress.com/2011/08/16/how-to-break-your-daily-caffeine-habit-and-use-coffee-strategically-fast-company/"
        }}>{`How To Break Your Daily Caffeine Habit And Use Coffee Strategically | Fast Company`}</a>{` (junaidghory.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=3c0c8898-abae-4e68-aa8a-d7d69c46edc8",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      